export enum CUSTOMER_MODE {
    PRIVATE = "private",
    PROFESSIONAL = "professional",
    B2B = "b2b"
}
